module.exports = __webpack_public_path__ + "static/media/motorway.d09a91e9.jpg";